import type { RefObject } from "react";
import React, { forwardRef } from "react";

import { InputContainer as DefaultInputContainer } from "../../../../helpers/common/CoreInputText/components/InputContainer/InputContainer";
import { useInputContainerStore } from "../../../../helpers/common/CoreInputText/store/inputContainerStore";
import { useCoreInputTextStore } from "../../../../helpers/common/CoreInputText/store/store";
import { Icon } from "../../../Icon";
import { Input } from "../../../InputText/components/Input/InputTextInput";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";
import { createDisplayNameForSearchElement } from "../../utils/getDisplayName";
import { createTestIdForSearchElement } from "../../utils/getTestId";
import Left from "../Left/SearchLeft";

import type { IInputContainerProps } from "../../../../helpers/common/CoreInputText/types";
import type { InputTextSize } from "../../../InputText/types";

import classes from "../../../../helpers/common/CoreInputText/CoreInputText.styl";

export interface ISearchInputContainerProps
    extends Omit<IInputContainerProps, "prefix"> {
    inputRef?: RefObject<HTMLInputElement>;
    placeholder?: string;
    defaultValue?: string;
    size?: InputTextSize;
    className?: string;
}

const INPUT_CONTAINER_TEST_ID = createTestIdForSearchElement("input-container");
const INPUT_CONTAINER_LABEL_TEST_ID = createTestIdForSearchElement(
    "input-container-label",
);

export const SearchInputContainer = forwardRef<
    HTMLLabelElement,
    ISearchInputContainerProps
>(({ ...props }, ref) => {
    const { inputId } = useCoreInputTextStore();
    const { inputChildren } = useInputContainerStore();

    return (
        <label
            htmlFor={inputId}
            className={classes["input-wrapper"]}
            data-tsid={INPUT_CONTAINER_LABEL_TEST_ID}
            data-uikit=""
            ref={ref}
        >
            <DefaultInputContainer
                as={Input}
                {...props}
                type="text"
                prefix={SEARCH_DISPLAY_NAME}
                data-tsid={INPUT_CONTAINER_TEST_ID}
            >
                <Left>
                    <Icon icon="glyph_search_24+" size="24" />
                </Left>
                {inputChildren}
            </DefaultInputContainer>
        </label>
    );
});

SearchInputContainer.displayName =
    createDisplayNameForSearchElement("InputContainer");
